<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Indent/index.html')">订单管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>售后管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="tableForm" class="search">
			<el-form-item label="订单号">
				<el-input v-model="tableForm.order_sn" clearable placeholder="订单号" size="small"></el-input>
			</el-form-item>
			<el-form-item label="状态">
				<el-select v-model="tableForm.state" clearable placeholder="请选择状态" size="small">
					<el-option label="进行中" value="1"></el-option>
					<el-option label="已拒绝" value="11"></el-option>
					<el-option label="已完成" value="21"></el-option>
					<el-option label="已取消" value="31"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="提交时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="tableForm.times" type="datetimerange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="search" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="list" border>
			<el-table-column prop="id" label="ID"></el-table-column>
			<el-table-column label="订单号" width="250">
				<template slot-scope="scope">
					<span>{{scope.row.orderMaster ? scope.row.orderMaster.order_sn : ''}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="real_name" label="用户" width="120">
				<template slot-scope="scope">

					<div class="avatar" v-if="scope.row.user">
						<img :src="scope.row.user.avatar" />
						{{scope.row.user.nick_name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="商品">
				<template slot-scope="scope">
					<div class="thumb" v-if="scope.row.orderGoods">
						<img :src="scope.row.orderGoods.pic_url" />
						{{scope.row.orderGoods.product_name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="类型">
				<template slot-scope="scope">
					<template v-if="scope.row.type == 1">仅退款</template>
					<template v-else-if="scope.row.type == 2">退货退款</template>
				</template>
			</el-table-column>
			<el-table-column label="付款金额">
				<template slot-scope="scope">
					{{scope.row.orderGoods.total_fee}} 元
				</template>
			</el-table-column>
			<el-table-column label="退款金额">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.refund_money > 0">{{scope.row.refund_money}} 元</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="状态">
				<template slot-scope="scope">
					<el-tag size="small" effect="dark" type="danger" v-if="scope.row.status == 0">进行中</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="scope.row.status == 10">已拒绝</el-tag>
					<el-tag size="small" effect="dark" v-else-if="scope.row.status == 20">已完成</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="scope.row.status == 30">已取消</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="时间"></el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)">查看</el-button>
					<el-button size="mini" type="primary" @click="push(scope.row.id)">推送</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
export default {
	data() {
		return {
			tableForm: {
				times: []
			},
			list: [],
			isLoad: false,
			pageSize: 20,
			page: 1,
			total: 0
		}
	},
	created() {
		this.loadList();
	},
	methods: {
		gotopage(url){
		     var link =  this.$router.resolve({
		     path: url
		   });
		   window.open(link.href, '_blank')
		},
		loadList() {
			this.isLoad = !this.isLoad
			this.axios.get('supplier/order.refund/list',{params:Object.assign({
					page:this.page,
					pagesize:this.pageSize
				}, this.tableForm)}).then(res => {
				this.isLoad = !this.isLoad
				this.list = res.data.list.data
				this.total = res.data.list.total
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		sizeReload(val) {
			this.page = 1
			this.pageSize = val
			this.loadList()
		},
		pageReload(val) {
			this.page = val
			this.loadList()
		},
		edit(id) {
			this.$router.push({
				path: '/Refund/edit.html',
				query: {
					id: id
				}
			});
		},
		add() {
			this.$router.push({
				path: '/User/edit.html'
			});
		},
		search: function () {
			this.page = 1
			this.loadList()
		},
		push: function (id) {
			this.isLoad = true
			this.axios.post('supplier/order.refund/push', {
				id: id,
			}).then(res => {
				this.isLoad = false
				this.$message.success({
					message: res.msg
				});
			}).catch(() => {
				this.isLoad = false
			})
		}
	}
}
</script>
<style scoped>
</style>
